import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";

const AuthenticatedRoute = ({ children }) => {
    const auth = useSelector((state) => state.auth);

    if (!auth.sessionInitialized) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                <CircularProgress />
            </Box>
        );
    }

    if (auth.account) {
        return (
            <>
                {children}
            </>
        );
    } else {
        return <Navigate to="/login" />;
    }
};

export default AuthenticatedRoute;
